"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
var LinksStatInterval;
(function (LinksStatInterval) {
    LinksStatInterval["ONE_DAY"] = "ONE_DAY";
    LinksStatInterval["FIVE_DAYS"] = "FIVE_DAYS";
    LinksStatInterval["ONE_MONTH"] = "ONE_MONTH";
    LinksStatInterval["ALL_TIME"] = "ALL_TIME";
})(LinksStatInterval = exports.LinksStatInterval || (exports.LinksStatInterval = {}));
class LinksStatsProvider extends DataProvider_1.default {
    get fragments() {
        return {
            LinksStat: () => `
        ... on LinksStat {
          userId
          totalClicks
          items {
            date
            clickCount
          }
        }
      `,
            LinksStatTotalSearchResult: () => `
        ... on LinksStatTotalSearchResult {
          result {
            ${this.getFragment("LinksStatTotal")}
          }
          hasNextPage
          hasPrevPage
          page
          size
          totalPages
          totalRecords
        }
      `,
            LinksStatTotal: () => `
        ... on LinksStatTotal {
          userId
          user {
            ${this.getFragment("UserPublicData")}
          }
          totalClicks
          link
        }
      `,
        };
    }
    linksClick({ data }) {
        return this.mutate("linksClick", { data });
    }
    linksStat({ data }) {
        return this.query("linksStat", { data }, this.getFragment("LinksStat"));
    }
    linksStatTotal({ data }) {
        return this.query("linksStatTotal", { data }, this.getFragment("LinksStatTotalSearchResult"));
    }
}
exports.LinksStatsProvider = LinksStatsProvider;
//# sourceMappingURL=LinksStatsProvider.js.map